import PropTypes from 'prop-types'
import React, { useRef, useState } from 'react'
import {
  ButtonSecondary,
  ScrollView,
  Input,
  AlertBannerError,
  SpacerVertical
} from 'mage-deps/@klarna/bubble-ui'
import FilesPreview from './FilesPreview'

const TOTAL_FILES_SIZE_LIMIT = 15 * 1048576

FilesInput.propTypes = {
  inputIcon: PropTypes.func,
  inputId: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  errorContent: PropTypes.array,
  white: PropTypes.bool
}

export default function FilesInput({ inputIcon, inputId, inputLabel, errorContent, white }) {
  const uploadLabelRef = useRef(null)
  const [fileInputValue, setFileInputValue] = useState('')
  const [fileError, setFileError] = useState(false)
  const [files, setFiles] = useState([])

  const fileInputOnChange = (value, e) => {
    const totalFilesSize = [...e.target.files].reduce((totalSize, file) => totalSize + file.size, 0)

    if (totalFilesSize >= TOTAL_FILES_SIZE_LIMIT) {
      setFileInputValue('')
      setFileError(true)
      setFiles([])
    } else {
      setFileInputValue(value)
      setFileError(false)
      setFiles([...e.target.files])
    }
  }

  return (
    <>
      <ScrollView style={{ alignItems: 'flex-start' }}>
        <ButtonSecondary
          icon={inputIcon}
          size="small"
          white={white}
          data-testid="upload"
          onClick={e => {
            uploadLabelRef.current.click()
            e.preventDefault()
          }}
        >
          {inputLabel}
        </ButtonSecondary>
      </ScrollView>
      <div data-testid="file-input-visibility-wrapper" style={{ display: 'none' }}>
        <label htmlFor={inputId} ref={uploadLabelRef} />
        <Input
          id={inputId}
          type="file"
          data-testid="file"
          value={fileInputValue}
          onChange={fileInputOnChange}
          multiple
          accept=".png, .jpg, .pdf, .jpeg"
        />
      </div>
      {fileError && (
        <>
          <SpacerVertical small />
          <AlertBannerError data-testid="file-error" content={errorContent} />
          <SpacerVertical small />
        </>
      )}
      <FilesPreview files={files} />
    </>
  )
}
